"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAuthorizedMenu = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MenuItem = require("../../MenuItem/MenuItem.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledAuthorizedMenu = _styledComponents.default.div.withConfig({
  displayName: "AuthorizedMenustyles__StyledAuthorizedMenu",
  componentId: "kursaw-0"
})(["border:none;background-color:", ";z-index:", ";", "{.c-menu-item-link-button{color:", ";}}.c-menu-grid-wrapper{display:flex;justify-content:center;flex-direction:column;align-items:stretch;}@supports (display:grid){@media only screen and (min-width:", "){display:grid;grid-template-areas:\"menu .\";grid-template-columns:8fr 1fr;}.c-menu-grid-wrapper{grid-area:menu;}}"], function (props) {
  return props.theme.c_background_brand;
}, function (props) {
  return props.theme.menu;
}, _MenuItem.StyledMenuItem, function (props) {
  return props.theme.c_foreground_overDark;
}, function (props) {
  return props.theme.maxWidth;
});

exports.StyledAuthorizedMenu = StyledAuthorizedMenu;